import * as csv from 'csv-parse/lib/sync';
// import * as plotly from 'plotly.js-dist';
import 'regenerator-runtime/runtime';
import katex from 'katex';
import {Buffer} from 'buffer';

window.Buffer = Buffer;
const KELVIN_OFFSET = 273.16

function toKelvin(temperature) {
    return temperature + KELVIN_OFFSET
}

function getIndexImage(tab) {
    let cas = 0;
    let i = 0;

    for (let elem in tab) {
        if (tab[elem] != 0) {
            cas = i;
            break;
        } else {
            i += 1;
        }
    }
    return cas
}

let lnAlphaImage = "";

function computeLnAlpha(equationsParams, kelvin) {
    const lnAImage = [
        6,
        4,
        3,
        2,
        1
    ];

    const a = parseFloat(equationsParams[0]) * Math.pow(10, 18) / Math.pow(kelvin, 6)
    const b = parseFloat(equationsParams[1]) * Math.pow(10, 12) / Math.pow(kelvin, 4)
    const c = parseFloat(equationsParams[2]) * Math.pow(10, 9) / Math.pow(kelvin, 3)
    const d = parseFloat(equationsParams[3]) * Math.pow(10, 6) / Math.pow(kelvin, 2)
    const e = parseFloat(equationsParams[4]) * Math.pow(10, 3) / kelvin
    const f = parseFloat(equationsParams[5])

    const tab = [a, b, c, d, e, f];
    const index = getIndexImage(tab);
    
    lnAlphaImage = lnAImage[index];
    return a + b + c + d + e + f
}

async function read_csv() {
    const response = await fetch('https://alphadelta.ggl.ulaval.ca/data/rres.csv', { method: 'GET'})
    .catch(error => {
        console.log(error);
    });
    const fileContent = await response.text();
    // break the textblock into an array of lines
    let contentTab = fileContent.split('\n');
    // remove one line, starting at the first position
    contentTab.splice(0,1);
    // join the array back into a single string
    let contentWithoutFirstLine = contentTab.join('\n');
    return csv.parse(contentWithoutFirstLine, {delimiter: ";"});
}

async function generateGraph(temperature, equation) {
    const xlabel = '$10^6/T^2(K)$';
    const ylabel = '$1000lnα_'+ '{'+ equation[6].split('<=>')[0] + '-' + equation[6].split('<=>')[1] + '}$'

    let tempList = [];
    let vallist = [];

    for (let t = 203.16; t < 2273.16; t+=10) {
        tempList.push(t);
    }

    tempList.forEach(t => {
        vallist.push(computeLnAlpha(equation, t));
    })

    for (let i = 0; i < tempList.length; i++) {
        tempList[i] = 1000000.0 / (tempList[i] * tempList[i]);
    }

    const trace = {
        x: tempList,
        y: vallist,
        type: 'lines',
        with: 2,
        line: {
            color: 'rgb(5, 102, 166)',
            width: 2,
        }
    }

    const temp = toKelvin(temperature);
    const lnAlpha = computeLnAlpha(equation, temp)
    const yVerticalLineCoord = 1000000.0 / (temp * temp);
    console.log(yVerticalLineCoord)
    const layout = {
        scrollZoom: false,
        xaxis: {
            linecolor: 'black',
            linewidth: 2,
            mirror: true,
            zeroline:false,
            title: xlabel,
            textposition: 'top',
        },
        yaxis: {
            linecolor: 'black',
            linewidth: 2,
            mirror: true,
            zeroline:false,
            title: ylabel
        },
        font: {
            size: 16
        },
        annotations: [
            {
                x: yVerticalLineCoord,
                y: Math.max.apply(Math, vallist),
                text: temperature.toFixed(1),
                showarrow: false,
                align: "right",
                xanchor: 'left',
            },
            {
                xref: 'paper',
                yref: 'paper',
                x: 0,
                xanchor: 'left',
                y: 0,
                yshift: -50,
                font: {size: 10},
                yanchor: 'top',
                text: 'http://alphadelta.ggl.ulaval.ca',
                showarrow: false
            
            },
            {
                x: Math.max.apply(Math, tempList),
                y: lnAlpha,
                text: lnAlpha.toFixed(1),
                showarrow: false,
                yanchor: 'bottom',
            }
        ],
        shapes: [
            {
                type: 'line',
                xref: 'paper',
                x0: 0,
                y0: lnAlpha,
                x1: 1,
                y1: lnAlpha,
                line:{
                    color: 'rgb(255, 0, 0)',
                    width: 2,
                },
            },
            {
                type: 'line',
                yref: 'paper',
                x0: yVerticalLineCoord,
                y0: 0,
                x1: yVerticalLineCoord,
                y1: 1,
                line:{
                    color: 'rgb(0, 128, 0)',
                    width: 2,
                }
            }
        ],
        title: '<b>T (C)<b>',
    }

    // renderKatex()
    await displayCorrectLn(equation);
    await Plotly.newPlot('chart', [trace], layout);
    document.getElementById("tempVal").innerHTML += temperature.toFixed(1) + " <sup>o</sup>C";
    document.getElementById("equationName").innerHTML += equation[6] + "; " + equation[8];
    document.getElementById("equationPrincipalName").innerHTML = equation[6];
    await setReference(parseInt(equation[9] - 1), parseInt(equation[10] - 1));
    return lnAlpha;
}

async function setReference(ref1, ref2) {
    const response = await fetch('https://alphadelta.ggl.ulaval.ca/data/refiso.prn', { method: 'GET'})
    .catch(error => {
        console.log(error);
    });
    const fileContent = await response.text();
    const fileParsed = fileContent.split("\n");
    if (ref1 >= 0) {
        document.getElementById("references").innerHTML = fileParsed[ref1] + "<br><br>";
    }
    if (ref2 >= 0) {
        document.getElementById("references").innerHTML += fileParsed[ref2];
    }
}

async function renderKatex() {
    const elem = document.getElementById("equationLatex");
    katex.render("\\frac{2}{3}", elem, { throwOnError: false });
}

async function main () {
    const params = new URLSearchParams(location.search);
    const temperature = parseFloat(params.get("-t").replace(",", "."));
    const equationIndex = parseFloat(params.get("-e"));

    if (params.get("-t") == "") {
        document.getElementById("errorId").innerHTML = "<b>Température non inscrite, reculez </br>\
        You did not enter a temperature value, go back</b>";
        return;
    }
    else if (params.get("-e") == null) {
        document.getElementById("errorId").innerHTML = "<b>Equation non sélectionnée, reculez</br>\
        Equation not selected, go back</b>";
        return;
    }

    const equations = await read_csv();
    const equation = equations[equationIndex];

    const lnAlpha = await generateGraph(temperature, equation);
    document.getElementById("valueLn").innerHTML += lnAlpha.toFixed(1)
}

let promise = new Promise(function(resolve, reject) {
    main();
    resolve();
  });

async function displayCorrectLn(equation) {
    const elem = document.getElementById("equationLatex");
    switch (lnAlphaImage) {
        case 1:
            katex.render("1000 \\, ln \\alpha = " + equation[4]+ "\\frac{10^3}{T} + " + equation[5], elem, {throwOnError: false});
            break;
        case 2:
            katex.render("1000 \\, ln \\alpha = " + equation[3] + "\\frac{10^6}{T^2} + " + equation[4]+ "\\frac{10^3}{T} + " + equation[5], elem, {throwOnError: false});
            break;
        case 3:
            katex.render("1000 \\, ln \\alpha = " + equation[2] + "\\frac{10^9}{T^3} + " + equation[3] +  "\\frac{10^6}{T^2} + " + equation[4]+ "\\frac{10^3}{T} + " + equation[5], elem, {throwOnError: false});
            break;
        case 4:
            katex.render("1000 \\, ln \\alpha = " + equation[1] + "\\frac{10^{12}}{T^4} + " + equation[2] + "\\frac{10^9}{T^3} + " + equation[3] +  "\\frac{10^6}{T^2} + " + equation[4]+ "\\frac{10^3}{T} + " + equation[5], elem, {throwOnError: false});
            break;
        case 6:
            katex.render("1000 \\, ln \\alpha = " + equation[0] + "\\frac{10^{18}}{T^6} + " + equation[1] + "\\frac{10^{12}}{T^4} + " + equation[2] + "\\frac{10^9}{T^3} + " + equation[3] +  "\\frac{10^6}{T^2} + " + equation[4]+ "\\frac{10^3}{T} + " + equation[5], elem, {throwOnError: false});
            break;
    }
    var testElements = document.getElementsByClassName('katex-html');
    for (let item of testElements) {
        item.parentNode.removeChild(item);
    }
}

promise.then(() => {
    console.log("computed");
})

